<span class="int-radio">
  <label class="int-radio__label">
    <span class="int-radio__field-wrap">
      <input class="int-radio__input"
       [type]="type"
       [name]="name"
       (change)="handleChange($event)"
       [checked]="isChecked"
       [disabled]="disabled"
       [readOnly]="readonly"
       [value]="value"
      >
      <span class="int-radio__decorator">
        <span class="int-radio__decorator-dot"></span>
      </span>
    </span>
    <span>
      <ng-content select="content"></ng-content>
      <ng-content></ng-content>
    </span>
  </label>
</span>
